<template>
    <div id="data-table">
        <vue-bootstrap4-table ref="vue-bootstrap4-table"
                              :rows="rows"
                              :columns="columns"
                              :classes="classes"
                              :config="config"
                              :actions="actions"
                              :totalRows="total_rows"
                              v-on="$listeners"
                              @on-change-query="onChangeQuery"
                              @refresh-data="fetchData"
                              @on-select-row="onSelectRow"
                              @on-all-select-rows="onAllSelectRows"
                              @on-unselect-row="onUnselectRow"
                              @on-all-unselect-rows="onAllUnselectRows">
            <template slot="reset-button-text">
                <i class="fas fa-times"></i> Szűrő törlése
            </template>
            <template slot="refresh-button-text">
                <i class="fas fa-sync-alt"></i> Frissítés
            </template>
            <template slot="buttons" slot-scope="props">
                <button v-for="(rowAction, index) in rowActions"
                        v-bind:key="index"
                        v-bind:class="rowAction.class"
                        v-bind:title="rowAction.title"
                        v-bind:value="props.row.id" class="table-action-button"
                        v-bind:disabled="setRowActionButtonDisable(props.row, rowAction)"
                        type="button"
                        @click="$emit('customClick', {event_payload: rowAction.event_payload}, props.row)"
                        v-if="setRowActionButtonVisible(props.row, rowAction, additionalData)"
                        v-html="rowAction.btn_text">
                </button>
            </template>
            <template slot="pagination-info" slot-scope="props">
                A találatok száma: {{props.filteredRowsLength}}
            </template>
            <template slot="empty-results">
                {{ $t('data-table.text.no-result') }}
            </template>
            <!-- Hagyományos row_select -->
            <template slot="row_select" slot-scope="{row, column} = props">
                <button class="btn btn-sm btn-success"
                        v-if="!isSelected(row, column)"
                        @click="onClickSelect(row,$event)"
                        title="Kiválasztás">
                    <i class="fas fa-plus"></i>
                </button>
                <button class="btn btn-sm btn-danger"
                        v-else
                        @click="onClickRemove(row,$event)"
                        title="Eltávolítás">
                    <i class="fas fa-minus"></i>
                </button>
            </template>
            <!-- A páciens összevonóhoz tartozó row_select -->
            <template slot="merging_patients_row_select" slot-scope="{row, column} = props">
                <button class="btn btn-sm btn-success"
                        v-if="!isPatientSelected(row, column)"
                        @click="onClickSelect(row)"
                        title="Kiválasztás">
                    <i class="fas fa-plus"></i>
                </button>
                <button class="btn btn-sm btn-danger"
                        v-else
                        @click="onClickRemove(row)"
                        title="Eltávolítás">
                    <i class="fas fa-minus"></i>
                </button>
            </template>
            <template slot="row_select_single" slot-scope="{row, column} = props">
                <button class="btn btn-sm btn-success"
                        v-if="!isChecked(row, column)"
                        @click="onClickCheck(row)"
                        :disabled="isDisabled(row, column)"
                        title="Kiválasztás">
                    <i class="fas fa-plus"></i>
                </button>
                <button class="btn btn-sm btn-danger"
                        v-else
                        @click="onClickRemoveCheck(row)"
                        title="Eltávolítás">
                    <i class="fas fa-minus"></i>
                </button>
            </template>
            <template slot="date_format" slot-scope="props">
                {{props.cell_value ? formatDate(props.cell_value) : ''}}
            </template>
            <template slot="settingDateFormatDateOfBirth" slot-scope="data">
                {{settingDateFormatDateOfBirth(data)}}
            </template>
            <template slot="settingDateFormatEmploymentRelationshipStartDate" slot-scope="data">
                {{settingDateFormatEmploymentRelationshipStartDate(data)}}
            </template>
            <template slot="settingDateFormatEmploymentRelationshipEndDate" slot-scope="data">
                {{settingDateFormatEmploymentRelationshipEndDate(data)}}
            </template>
            <template slot="dateMonthFormat" slot-scope="props">
                {{dateMonthFormat(props.cell_value)}}
            </template>
            <template slot="datetime_format" slot-scope="props">
                {{formatDatetime(props.cell_value)}}
            </template>
            <template slot="appointment_format" slot-scope="props">
                {{formatDatetime(props.cell_value)}}
            </template>
            <template slot="employability_created_on_format" slot-scope="props">
              {{formatDatetime(props.cell_value)}}
            </template>
            <template slot="today_appointment_format" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="formatTodayDatetime(data)"></div>
            </template>
            <template slot="expiration_date_format_color" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="formatAndColorExpirationDateTime(data.row)"></div>
            </template>
            <template slot="tooltip_for_laboratory_types" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="tooltipForLaboratoryTypes(data.row)"></div>
            </template>
            <template slot="created_on_format" slot-scope="props">
                {{formatDatetime(props.cell_value)}}
            </template>
            <template slot="modified_on_format" slot-scope="props">
                {{formatDatetime(props.cell_value)}}
            </template>
            <template slot="hist_created_on_format" slot-scope="props">
                {{formatDatetime(props.cell_value)}}
            </template>
            <template slot="status_format" slot-scope="props">
                <span v-html="formatDeleted(props.cell_value)"></span>
            </template>
            <template slot="isBasic_format" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="isOccupationHealth_format" slot-scope="props">
                <span v-html="isForPackageFormatCheck(props.cell_value)"></span>
            </template>
            <template slot="shareWithOccupationHealth_format" slot-scope="props">
                <span v-html="isForPackageFormatCheck(props.cell_value)"></span>
            </template>
            <template slot="disableEmail_format" slot-scope="props">
                <span v-html="isForPackageFormatCheck(props.cell_value)"></span>
            </template>
            <template slot="besorolasok_normativ_format" slot-scope="data">
            <div style="height: 100%" class="w-100" v-html="formatIcon(data.row, 'normativ')"></div>
            </template>
            <template slot="besorolasok_kozgyogy_format" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="formatIcon(data.row, 'kozgyogy')"></div>
            </template>
            <template slot="besorolasok_uzemi_format" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="formatIcon(data.row, 'uzemi')"></div>
            </template>
            <template slot="besorolasok_honvedelmi_format" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="formatIcon(data.row, 'honvedelmi')"></div>
            </template>
            <template slot="besorolasok_emelt_format" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="formatIcon(data.row, 'emelt')"></div>
            </template>
            <template slot="besorolasok_kiemelt_format" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="formatIcon(data.row, 'kiemelt')"></div>
            </template>
            <template slot="combined_text_format" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="combinedFunction(data.row)"></div>
            </template>
            <template slot="productionTime_format" slot-scope="props">
                {{props.cell_value ? formatDate(props.cell_value) : ''}}
            </template>
            <template slot="examinationDate_format" slot-scope="props">
                {{props.cell_value ? formatDate(props.cell_value) : ''}}
            </template>
            <template slot="authenticationTime_format" slot-scope="props">
                {{props.cell_value ? formatDate(props.cell_value) : ''}}
            </template>
            <template slot="authenticationTimeTo_format" slot-scope="props">
                {{props.cell_value ? formatDate(props.cell_value) : ''}}
            </template>
            <template slot="deleted_format" slot-scope="props">
                <span v-html="formatDeleted(props.cell_value)"></span>
            </template>
            <template slot="cycleFrom_format" slot-scope="props">
                {{props.cell_value ? formatDate(props.cell_value) : ''}}
            </template>
            <template slot="cycleTo_format" slot-scope="props">
                {{props.cell_value ? formatDate(props.cell_value) : ''}}
            </template>
            <template slot="fullPoint_format" slot-scope="data">
                {{fullPointFormat(data.row)}}
            </template>
            <template slot="educationStartDate_format" slot-scope="props">
                {{props.cell_value ? formatDate(props.cell_value) : ''}}
            </template>
            <template slot="educationEndDate_format" slot-scope="props">
                {{props.cell_value ? formatDate(props.cell_value) : ''}}
            </template>
            <template slot="start_end_date_fromatter" slot-scope="data">
                {{startEndDateFormatter(data.row)}}
            </template>
            <template slot="start_end_time_fromatter" slot-scope="data">
                {{startEndTimeFormatter(data.row)}}
            </template>
            <template slot="repeats_formatter" slot-scope="data">
                {{repeatsFormatter(data.row)}}
            </template>
            <template slot="days_formatter" slot-scope="data">
                {{daysFormatter(data.row)}}
            </template>
            <template slot="holidayDateFromTo_format" slot-scope="data">
                {{formatHolidayDateFromTo(data.row)}}
            </template>
            <template slot="companySite_format" slot-scope="data">
                {{companySiteFormat(data.row)}}
            </template>
            <template slot="formatEmployeeStatus" slot-scope="data">
                <span v-html="formatEmployeeStatus(data.row)"></span>
            </template>
            <template slot="operation_format" slot-scope="props">
                {{operationFormat(props.cell_value)}}
            </template>
            <template slot="resultDate_format" slot-scope="props">
                {{formatDate(props.cell_value)}}
            </template>
            <template slot="startDate_format" slot-scope="props">
                {{formatDate(props.cell_value)}}
            </template>
            <template slot="isClosed_format" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="boolean_format" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="patientNameFormat" slot-scope="data">
                {{patientNameFormat(data.row)}}
            </template>
            <template slot="patientPhoneNumberFormat" slot-scope="data">
                {{patientPhoneNumberFormat(data.row)}}
            </template>
            <template slot="birthdate_format" slot-scope="props">
                {{formatDate(props.cell_value)}}
            </template>
            <!-- itt van valami format -->
            <template slot="startdate_format" slot-scope="props">
                {{formatDate(props.cell_value)}}
            </template>
            <template slot="resultdate_format" slot-scope="props">
                {{formatDate(props.cell_value)}}
            </template>
            <template slot="dateOfBirth_format" slot-scope="props">
                {{formatDate(props.cell_value)}}
            </template>
            <template slot="startDate_format" slot-scope="props">
                {{formatDate(props.cell_value)}}
            </template>
            <template slot="endDate_format" slot-scope="props">
                {{formatDate(props.cell_value)}}
            </template>
            <template slot="referral_format" slot-scope="props">
                {{formatDate(props.cell_value)}}
            </template>
            <template slot="beutaloOrvos_format" slot-scope="data">
                {{beutaloOrvosFormat(data.row)}}
            </template>
            <template slot="esemenyStatus_format" slot-scope="props">
                {{formatEsemenyStatus(props.cell_value)}}
            </template>
            <template slot="esemenyTipus_format" slot-scope="props">
                {{formatEsemenyTipus(props.cell_value)}}
            </template>
            <template slot="operationStart_format" slot-scope="data">
                {{formatOperationStart(data.row)}}
            </template>
            <template slot="operationEnd_format" slot-scope="data">
                {{formatOperationEnd(data.row)}}
            </template>
            <template slot="loaded_format" slot-scope="data">
                <span v-html="formatLoaded(data.row)"></span>
            </template>
            <template slot="success_format" slot-scope="data">
                <span v-html="isSuccessfulForRow(data.row)"></span>
            </template>
            <template slot="company_format" slot-scope="data">
                <span v-html="isCompanyOrPrivatePerson(data.row)"></span>
            </template>
            <template slot="stornoFormat" slot-scope="props">
                <span v-html="stornoFormat(props.cell_value)"></span>
            </template>
            <template slot="proformaInvoicePaidFormat" slot-scope="props">
                <span v-html="proformaInvoicePaidFormat(props.cell_value)"></span>
            </template>
            <template slot="is_synlab_type_icon" slot-scope="data">
                <span v-html="synlabTypeIconFormat(data)"></span>
            </template>
            <template slot="is_synlab_type_package_icon" slot-scope="data">
                <span v-html="synlabTypePackageIconFormat(data)"></span>
            </template>
            <template slot="is_synlab_type_icon_for_labs" slot-scope="props">
                <span v-html="synlabTypeIconFormatForLabs(props.cell_value)"></span>
            </template>
            <template slot="isThisTheActualDate" slot-scope="props">
                <span v-html="formatDatetimeCheckIfDateIsNotActual(props.cell_value)"></span>
            </template>
            <template slot="isNull" slot-scope="props">
                <span v-html="isNullFormat(props.cell_value)"></span>
            </template>
            <template slot="isNull2" slot-scope="props">
                <span v-html="isNullFormat(props.cell_value)"></span>
            </template>
            <template slot="commission_format" slot-scope="props">
                {{formatCommission(props.cell_value)}}
            </template>
            <template slot="currencyFormat" slot-scope="props">
                {{formatCommission(props.cell_value)}}
            </template>
            <template slot="currencyFormat2" slot-scope="props">
                {{formatCommission(props.cell_value)}}
            </template>
            <template slot="currencyFormat3" slot-scope="props">
                {{formatCommission(props.cell_value)}}
            </template>
            <template slot="treatment_price_format" slot-scope="props">
                {{formatCommission(props.cell_value)}}
            </template>
            <template slot="commission_format2" slot-scope="props">
                {{formatCommission2(props.cell_value)}}
            </template>
            <template slot="commissionAmountFormat" slot-scope="data">
                {{commissionAmountFormat(data.row)}}
            </template>
            <template slot="date_month_format" slot-scope="props">
                {{formatDateMonth(props.cell_value)}}
            </template>
            <template slot="gyogyszer_szinezes" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="gyogyszerSzinezes(data.row)"></div>
            </template>
            <template slot="gyogyszerSzinezesForgalomban" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="gyogyszerSzinezesForgalomban(data.row)"></div>
            </template>
            <template slot="formatGYSE" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="formatGYSE(data.row)"></div>
            </template>
            <template slot="eupont_format" slot-scope="data">
                {{formatEupont(data.row)}}
            </template>
            <template slot="companySite_deactivation_format" slot-scope="props">
                <span v-html="companySiteDeactivationFormat(props.cell_value)"></span>
            </template>
            <template slot="rowSelect" slot-scope="props">
                <div :data-id="props.row.id">
                    {{ props.cell_value }}
                </div>
            </template>
            <template slot="examCodeRowSelect" slot-scope="props">
                <div :data-id="props.row.id">
                    <span v-if="props.row.codeNum">{{props.row.codeNum}}</span>
                    <span v-if="props.row.perjel && props.row.codeNum">/</span>
                    <span v-if="props.row.perjel">{{props.row.perjel}}</span>
                </div>
            </template>
            <template slot="recommendedDosageFormat" slot-scope="props">
                {{props.cell_value}}
            </template>
            <template slot="noFormat" slot-scope="props">
                {{props.cell_value}}
            </template>
            <template slot="noFormat2" slot-scope="props">
                {{props.cell_value}}
            </template>
            <!-- <template slot="price" slot-scope="">
                <b-form-group class="smooth-form-group">
                    <b-form-input type="number"></b-form-input>
                    <label class="smooth-label"></label>
                </b-form-group>
            </template> -->
            <template slot="eeszt_status_format" slot-scope="props">
                {{eesztStatusFormat(props.cell_value)}}
            </template>
            <template slot="format_eeszt_cert" slot-scope="props">
                <span v-html="formatEesztCert(props.cell_value)"></span>
            </template>
            <template slot="bno_szinezes" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="bnoSzinezes(data.row)"></div>
            </template>
            <template slot="format_patient" slot-scope="props">
                <span v-html="formatPatient(props.cell_value)"></span>
            </template>
            <template slot="checkFormat1" slot-scope="props">
                <span v-html="formatCheckTwoState(props.cell_value)"></span>
            </template>
            <template slot="checkFormat2" slot-scope="props">
                <span v-html="formatCheckTwoState(props.cell_value)"></span>
            </template>
            <template slot="checkFormat3" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat4" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat5" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat6" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat7" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat8" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat9" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat10" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat11" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat12" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat13" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat14" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat15" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat16" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat17" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat18" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat19" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat20" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat21" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat22" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat23" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat24" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat25" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat26" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat27" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat28" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat29" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat30" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat31" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat32" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat33" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat34" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat35" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat36" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat37" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat38" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat39" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat40" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat41" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat42" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat43" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat44" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="checkFormat45" slot-scope="props">
                <span v-html="formatCheck(props.cell_value)"></span>
            </template>
            <template slot="history_validatedOn" slot-scope="props">
                <span v-html="historyValidatedDateCheck(props)"></span>
            </template>
            <template slot="bnoKodFormat" slot-scope="props">
                <span v-html="bnoKodFormat(props)"></span>
            </template>
            <template slot="bnoKodFormat1" slot-scope="props">
                <span v-html="bnoKodFormat(props)"></span>
            </template>
            <template slot="protocol_format" slot-scope="props">
                {{protocolFormat(props.cell_value)}}
            </template>
            <template slot="email_status_format" slot-scope="props">
                {{emailStatusFormat(props.cell_value)}}
            </template>
            <template slot="appointment_status_color" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="appointmentStatusColorCode(data.row)"></div>
            </template>
            <template slot="currencyFormatByCurrencyType1" slot-scope="props">
                {{currencyFormatByCurrencyType(props.cell_value, props.row.currency)}}
            </template>
            <template slot="currencyFormatByCurrencyType2" slot-scope="props">
                {{currencyFormatByCurrencyType(props.cell_value, props.row.currency)}}
            </template>
            <template slot="currencyFormatByCurrencyType3" slot-scope="props">
                {{currencyFormatByCurrencyType(props.cell_value, props.row.currency)}}
            </template>
            <template slot="version_format" slot-scope="props">
                {{formatVersion(props.cell_value)}}
            </template>

            <template slot="currencyFormat1" slot-scope="props">
                {{formatCommission2(props.cell_value)}}
            </template>
            <template slot="currencyFormat2" slot-scope="props">
                {{formatCommission2(props.cell_value)}}
            </template>
            <template slot="currencyFormat3" slot-scope="props">
                {{formatCommission2(props.cell_value)}}
            </template>
            <template slot="currencyFormat4" slot-scope="props">
                {{formatCommission2(props.cell_value)}}
            </template>
            <template slot="currencyFormat5" slot-scope="props">
                {{formatCommission2(props.cell_value)}}
            </template>
            <template slot="currencyFormat6" slot-scope="props">
                {{formatCommission2(props.cell_value)}}
            </template>
            <template slot="formatCheckByZeroOrOne1" slot-scope="props">
                <span v-html="formatCheckByZeroOrOne(props.cell_value)"></span>
            </template>
            <template slot="formatCheckByZeroOrOne2" slot-scope="props">
                <span v-html="formatCheckByZeroOrOne(props.cell_value)"></span>
            </template>
            <template slot="formatExpiredPackage" slot-scope="props">
                <span v-html="formatExpiredPackages(props.cell_value)"></span>
            </template>
            <template slot="formatMaleOrFemale" slot-scope="props">
                <span v-html="formatMaleOrFemale(props.cell_value)"></span>
            </template>
            <template slot="mihaidFormat" slot-scope="props">
                {{mihaidFormat(props.cell_value)}}
            </template>
            <template slot="mihastatFormat" slot-scope="props">
                {{mihastatFormat(props.cell_value)}}
            </template>
            <template slot="tamtechnFormat" slot-scope="props">
                {{tamtechnFormat(props.cell_value)}}
            </template>
            <template slot="formatKulonl100" slot-scope="props">
                <span v-html="formatKulonl100(props.cell_value)"></span>
            </template>
            <template slot="puphaXTermekszinezes" slot-scope="data">
                <div style="height: 100%" class="w-100" v-html="puphaXTermekszinezes(data.row)"></div>
            </template>
            <template slot="indikaciokFormat" slot-scope="data">
                {{indikaciokFormat(data.row)}}
            </template>
            <template slot="kategoriaPuphaxFormat" slot-scope="data">
                {{kategoriaPuphaxFormat(data.row)}}
            </template>
            <template slot="validated_format" slot-scope="props">
                <span v-html="validateFormat(props.cell_value)"></span>
            </template>

            <template slot="isForpackageFormat" slot-scope="props">
                <span v-html="isForPackageFormatCheck(props.cell_value)"></span>
            </template>
            <template slot="isForBillingFormat" slot-scope="props">
                <span v-html="isForBillingFormatCheck(props.cell_value)"></span>
            </template>
            <template slot="isForCodingFormat" slot-scope="props">
                <span v-html="isForCodingFormatCheck(props.cell_value)"></span>
            </template>
            <template slot="percent_format" slot-scope="props">
                <div style="height: 100%" class="w-100" v-html="percentFormat(props.cell_value)"></div>
            </template>
            <template slot="sumDuration_format" slot-scope="props">
                <div style="height: 100%" class="w-100" v-html="sumDurationFormat(props.cell_value)"></div>
            </template>
            <template slot="sumMinPerDay_format" slot-scope="props">
                <div style="height: 100%" class="w-100" v-html="sumMinPerDayFormat(props.cell_value)"></div>
            </template>
            <template slot="rowBreakAtComa" slot-scope="data">
                <!-- ez csak az orvos napi ellátás listánál működik a felkódólt kezelésre vagy codedTreatments nevü elemre ha van valaki okos akkor az javítsa ki h mindenre jó legyen -->
                <p v-html="rowBreakAtComaFormat(data.row)"></p>
            </template>
            <template slot="isContactPartner" slot-scope="data">
                <p v-html="isContactPartner(data.row)"></p>
            </template>
            <template slot="preTagFormat" slot-scope="props">
                <p v-html="preTagFormat(props.cell_value)"></p>
            </template>
            <template slot="truncateString" slot-scope="props">
                <p v-html="truncateString(props.cell_value)"></p>
            </template>
            <template slot="rowBreakAtSign" slot-scope="data">
                <p v-html="rowBreakAtEndSignFormat(data.row)"></p>
            </template>
            <template slot="rowBreakAtSemicolon" slot-scope="data">
                <p v-html="rowBreakAtSemicolon(data.row)"></p>
            </template>
            <template slot="action_text_format" slot-scope="data">
                <p v-html="rowBreakAtDotFormat(data.row)"></p>
            </template>
            <template slot="interval_format" slot-scope="data">
                <p v-html="intervalToNoDecimalFormat(data.row)"></p>
            </template>
          <template slot="time_with_seconds_to_hour_formatter" slot-scope="data">
            <p v-html="TimeWithSecondsToHoursFormatter(data.row)"></p>
          </template>
          <template slot="isConnectedToManagerFormat" slot-scope="data">
            <span v-html="isConnectedToManager(data.row)"></span>
          </template>
          <template slot="isRichterFormat" slot-scope="data">
            <span v-html="isRichter(data.row)"></span>
          </template>
          <template slot="isTIGFormat" slot-scope="data">
            <span v-html="isTIG(data.row)"></span>
          </template>
          <template slot="isSiteCcCodeUsedFormat" slot-scope="data">
                <span v-html="isSiteCcCodeUsed(data.row)"></span>
          </template>
        </vue-bootstrap4-table>

        <NotificationModal ref="eesztDorWarningModal"
                           :modalTitle="'Digitális Önrendelkezés (DÖR) figyelmeztetés'"
                           :modalText="'<p>A lekérdezés eredménye Digitális Önrendelkezés (DÖR) miatt nem teljes! Amennyiben szükséges, <b>Sürgős lekérdezés</b>sel újra lekérdezheti az adatokat indoklás megadása után.</p>'"/>
    </div>
</template>

<script>
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import Util from "../util/Util"
    import UserUtil from "../util/UserUtil";
    import {mapGetters} from "vuex";
    import NotificationModal from "./NotificationModal";

    export default {
        name: 'DataTable',
        props: {
            columns: {type: Array},
            actions: {type: Array},
            rowActions: {type: Array},
            apiCallback: {type: Function},
            additionalConfig: {type: Object},
            additionalData: {type: Object},
            inputData: {type: Array},
            orderBy: {type: Array, default: () => [false, 'name']}, //abc sorrendbe rakja a táblázatot,
            isSpecificDoctorId: {type: Number}
        },
        data: function () {
            return {
                rows: [],
                classes: {
                    table: {
                        "table-striped table-bordered": true
                    }
                },
                config: {
                    preservePageOnDataChange: true,
                    pagination: true,
                    num_of_visible_page: 7,
                    server_mode: false,
                    per_page: 10,
                    per_page_options: [5, 10, 20, 30],
                    selected_rows_info: true,
                    checkbox_rows: false,
                    show_refresh_button: true,
                    show_reset_button: false,
                    initOnRender: true,
                    global_search: {
                        placeholder: "Keresés...",
                        visibility: false,
                        case_sensitive: false,
                        showClearButton: false,
                        searchOnPressEnter: false,
                        searchDebounceRate: 1000
                    },
                    ...this.additionalConfig
                },
                queryParams: {
                    sort: [],
                    filters: [],
                    global_search: "",
                    per_page: 20,
                    page: 0,
                },
                total_rows: 0
            }
        },
        methods: {
            isConnectedToManager(managerExists){
                if (managerExists.isConnectedToManager) {
                    return '<i class="fas fa-check" data-toggle="tooltip" data-placement="right" title="Igen" style="color: green"></i>';
                } else {
                    return '<i class="fas fa-times" data-toggle="tooltip" data-placement="right" title="Nem" style="color: red"></i>';
                }
            },
            isSiteCcCodeUsed(value){
                if (value.useSiteCcCode) {
                    return '<i class="fas fa-check" data-toggle="tooltip" data-placement="right" title="Igen" style="color: green"></i>';
                } else {
                    return '<i class="fas fa-times" data-toggle="tooltip" data-placement="right" title="Nem" style="color: red"></i>';
                }
            },
            isRichter(row){
                if (row.isRichter) {
                    return '<i class="fas fa-check" data-toggle="tooltip" data-placement="right" title="Igen" style="color: green"></i>';
                } else {
                    return '<i class="fas fa-times" data-toggle="tooltip" data-placement="right" title="Nem" style="color: red"></i>';
                }
            },
            isTIG(row){
                if (row.tigEnabled) {
                    return '<i class="fas fa-check" data-toggle="tooltip" data-placement="right" title="Igen" style="color: green"></i>';
                } else {
                    return '<i class="fas fa-times" data-toggle="tooltip" data-placement="right" title="Nem" style="color: red"></i>';
                }
            },
            isSelected(row, column) {
                if (column.values === undefined) {
                    return false;
                } else if (column.values === null) {
                    return column.values;
                } 
                else {
                    if(!row.kod){
                        if(row.id){
                            return column.values.filter(item => item.id === row.id).length > 0;
                        } else {
                            return column.values.filter(item => item.idTermek === row.idTermek).length > 0;
                        }
                    }
                    else{
                        return column.values.filter(item => item.kod === row.kod).length > 0;
                    }
                }
            },
            isPatientSelected(row, column){
                return column.values.filter(item => {
                    if (item.id){
                        return item.id === row.id
                    }
                    return item.kod === row.kod
                }).length > 0;
            },
            isChecked(row, column) {
                return column.value && column.value === row.id

            },
            isDisabled(row, column) {
                return !column.values.map(item => item.id).includes(row.id)
            },
            onClickCheck(row) {
                this.$emit('customClick', {event_payload: 'checkRow'}, row);
            },
            onClickSelect(row,event) {
                this.$emit('customClick', {event_payload: 'selectRow'}, row, event  );
            },
            onClickRemoveCheck(row) {
                this.$emit('customClick', {event_payload: 'removeCheckRow'}, row);
            },
            onClickRemove(row, event) {
                this.$emit('customClick', {event_payload: 'removeRow'}, row, event);
            },
            onChangeQuery(queryParams) {
                this.queryParams = queryParams;
                this.fetchData();
            },
            formatDate(date) {
                if (date) {
                    return this.$moment(date).format("YYYY.MM.DD.");
                } else {
                    return "";
                }
            },
            settingDateFormatDateOfBirth(data) {
                if (data.row.dateOfBirth) {
                    data.row.dateOfBirth = this.$moment(data.row.dateOfBirth).format("YYYY.MM.DD.");
                    return data.row.dateOfBirth
                } else {
                    return "";
                }
            },
            settingDateFormatEmploymentRelationshipStartDate(data) {
                if (data.row.employmentRelationshipStartDate) {
                    data.row.employmentRelationshipStartDate = this.$moment(data.row.employmentRelationshipStartDate).format("YYYY.MM.DD.");
                    return data.row.employmentRelationshipStartDate
                } else {
                    return "";
                }
            },
            settingDateFormatEmploymentRelationshipEndDate(data) {
                if (data.row.employmentRelationshipEndDate) {
                    data.row.employmentRelationshipEndDate = this.$moment(data.row.employmentRelationshipEndDate).format("YYYY.MM.DD.");
                    return data.row.employmentRelationshipEndDate
                } else {
                    return "";
                }
            },
            onSelectRow(payload) {
                this.$emit('onSelectRow', payload);
            },
            onAllSelectRows(payload) {
                this.$emit('onAllSelectRows', payload);
            },
            onUnselectRow(payload) {
                this.$emit('onUnselectRow', payload);
            },
            onAllUnselectRows(payload) {
                this.$emit('onAllUnselectRows', payload,this.rows);
            },
            fetchData() {
                const self = this;

                // Clear selection if using checkbox rows
                if (this.config.checkbox_rows) {
                    // this.$refs['vue-bootstrap4-table'].unSelectAllItems();
                }

                // filters and sort
                const filter = {};
                this.queryParams.filters.forEach(item => {
                    filter[item.name] = item.text;
                });

                const sort = {};
                this.queryParams.sort.forEach(item => {
                    sort.column = item.name;
                    sort.orderAsc = item.order === 'asc';
                });

                if (this.apiCallback) {
                    this.$loading(true);

                    setTimeout(() => {
                        // Ensures apiCallback returns a Promise
                        const callbackResult = self.apiCallback(
                            self.config.server_mode === true
                                ? { params: {
                                    pageIndex: self.queryParams.page - 1,
                                    pageSize: self.queryParams.per_page,
                                    filter: filter,
                                    sort: sort
                                }}
                                : {}
                        );

                        // Defensive check
                        const promise = (callbackResult && typeof callbackResult.then === 'function')
                            ? callbackResult
                            : Promise.resolve({ data: [] });

                        promise
                            .then(response => {
                                self.$loading(false);

                                // Assign rows
                                self.rows = response.data.Rows || response.data;
                                self.total_rows = response.data.Total || self.rows.length;

                                // Optional sorting
                                if (self.orderBy[0]) {
                                    self.rows = self.rows.sort((a, b) => {
                                        const aValue = a[self.orderBy[1]]?.trim() || '';
                                        const bValue = b[self.orderBy[1]]?.trim() || '';

                                        if (!aValue && !bValue) return 0;
                                        if (!aValue) return 1;
                                        if (!bValue) return -1;

                                        return aValue.localeCompare(bValue);
                                    });
                                }

                                self.$emit('getRows', self.rows);
                            })
                            .catch(errMsg => {
                                self.$loading(false);
                                console.error(errMsg);
                                self.rows = [];

                                const reason = errMsg?.response?.data?.reason;
                                const type = errMsg?.response?.data?.type;

                                if (reason) {
                                    if (type === 'WARN') {
                                        self.$toast.warn({ title: 'Figyelem', message: reason });
                                    } else {
                                        self.$toast.error({ title: 'Sikertelen lekérdezés', message: reason });
                                    }
                                }
                            });
                    });
                } else {
                    // Fallback to inputData
                    this.rows = this.inputData || [];
                    this.$emit('getRows', this.rows);
                }
            },
            uncheckAllSelectedRowItems() {
                this.$refs['vue-bootstrap4-table'].unSelectAllItems();
            },
            dateMonthFormat(date) {
                if (date) {
                    return this.$moment(date).format("YYYY.MM.");
                } else {
                    return "";
                }
            },
            isForPackageFormatCheck(isForPackage){
                if (isForPackage) {
                    return '<i class="fas fa-check" data-toggle="tooltip" data-placement="right" title="Igen" style="color: green"></i>';
                } else {
                    return '<i class="fas fa-times" data-toggle="tooltip" data-placement="right" title="Nem" style="color: red"></i>';
                }
            },
            isForBillingFormatCheck(isForBilling){
                if (isForBilling) {
                    return '<i class="fas fa-check" data-toggle="tooltip" data-placement="right" title="Igen" style="color: green"></i>';
                } else {
                    return '<i class="fas fa-times" data-toggle="tooltip" data-placement="right" title="Nem" style="color: red"></i>';
                }
            },
            isForCodingFormatCheck(isForCoding){
                if (isForCoding) {
                    return '<i class="fas fa-check" data-toggle="tooltip" data-placement="right" title="Igen" style="color: green"></i>';
                } else {
                    return '<i class="fas fa-times" data-toggle="tooltip" data-placement="right" title="Nem" style="color: red"></i>';
                }
            },
            percentFormat(percent){
                if (percent <= 35) {
                    return '<div class="bg-success"  data-placement="right">' + percent + ' %' + '</div>';
                } else if(percent <= 65){
                     return '<div class="bg-warning" data-placement="right" >' + percent + ' %' + '</div>';
                }else {
                    return '<div class="bg-danger" data-placement="right">' + percent + ' %' + '</div>';
                }
            },
            sumDurationFormat(sumDuration) {
                 return '<div>' + sumDuration + ' perc' + '</div>';
            },
            sumMinPerDayFormat(sumMinPerDay) {
                 return '<div>' + sumMinPerDay + ' perc' + '</div>';
            },
            formatDatetime(date) {
                if (date) {
                    return this.$moment(date).format("YYYY.MM.DD. HH:mm");
                } else {
                    return "";
                }
            },
            formatTodayDatetime(data) {
                if (data.row.appointmentDate) {
                    data.row.appointmentDate = this.$moment(data.row.appointmentDate).format("YYYY.MM.DD. HH:mm");
                    let now = new Date();
                    if (this.$moment(data.row.appointmentDate).isAfter(now, 'day')) {
                        return '<div class="bg-danger" data-toggle="tooltip" data-placement="right" title="Jövőbeni foglalás">' + data.row.appointmentDate + '</div>';
                    } else if (this.$moment(data.row.appointmentDate).isBefore(now, 'day')) {
                        return '<div class="bg-warning" data-toggle="tooltip" data-placement="right" title="Múltbeli foglalás">' + data.row.appointmentDate + '</div>';
                    } else {
                        return '<div class="bg-success" data-toggle="tooltip" data-placement="right" title="Mai foglalás">' + data.row.appointmentDate + '</div>';
                    }
                } else {
                    return "";
                }
            },
            formatDateMonth(date) {
                if (date) {
                    return this.$moment(date).format('YYYY.MM.');
                } else {
                    return "";
                }
            },
            formatDeleted(deleted) {
                if (deleted === 0) {
                    return '<i class="fas fa-check" title="Aktív"></i>';
                } else {
                    return '<i class="fas fa-trash-alt" title="Törölt"></i>';
                }
            },
            /**
             * Itt eredetileg a formatCheck fgv. volt használva,
             * és csak 2 értéket nézett: true/false
             * Néhány esetben be lett vezetve a null érték figyelése is,
             * (a default false helyett)
             * de mivel ez máshol is volt használva, inkább átneveztem
             * ld. #21
             * TODO az egész slotos dolgot átnézni, hogy ne legyen ennyi
             * ismétlődés
             */
            formatCheckTwoState(condition) {
                if (condition) {
                    return '<i class="fas fa-check" title="Igen"></i>';
                } else {
                    return '<i class="fas fa-minus" title="Nem"></i>';
                }
            },
            /**
             * true/false/null értékek megformázása
             */
            isSuccessfulForRow(rowData){
                if (rowData.isSuccesful === true) {
                    return "Sikeres";
                } else {
                    return "Sikertelen"; //<i class="fa-solid fa-x"></i>
                }
            },
            isCompanyOrPrivatePerson(rowData){
                if (rowData.company === true) {
                    return "Cég";
                } else {
                    return "Magánszemély"; 
                }
            },
            historyValidatedDateCheck(rowData){
                if (rowData.cell_value != null) {
                    if(rowData.row.statusId == 153004){
                        return this.$moment(rowData.cell_value).format("YYYY.MM.DD. HH:mm") + "<br>" + " (Felnyitás előtti validálás dátuma)";
                    }else{
                        return this.$moment(rowData.cell_value).format("YYYY.MM.DD. HH:mm");
                    }
                } else {
                    return "Validálás nem történt"; 
                }
            },
            formatCheck(condition) {
                if (condition === true) {
                    return '<i class="fas fa-fw fa-check" title="Igen"></i>';
                }
                if (condition === false) {
                    return '<i class="fas fa-fw fa-ban" title="Nem"></i>';
                }
                return  '<i class="fas fa-fw fa-question" title="Nem volt kiválasztva">'
            },
            formatIcon(rowData, key) {
                const besorolas = rowData.besorolasokObject;
                if (besorolas && besorolas[key] === true) {
                    return '<i class="fas fa-check text-green" style="color:green;" title="Igen"></i>';    
                } else {
                    return '<i class="fas fa-times text-red" style="color:red" title="Nem"></i>';
                }
            },
            formatLongText(text) {
            if (text.length >= 19) {
                for (let i = 19; i < text.length; i++) {
                    if (text[i] === ' ') {
                        return text.substring(0, i) + '<br>' + text.substring(i);
                        }
                    }
                }
                return text;
            },
            //gyogyszerszinezes + formatLongText
            combinedFunction(rowData) {
                let formattedText = this.formatLongText(rowData.nev);
                if (rowData.megszunt === true) {
                    return '<div class="bg-danger" data-toggle="tooltip" data-placement="right" title="A termék nincs forgalomban!">' + formattedText + '</div>';
                } else {
                    return '<div class="bg-transparent">' + formattedText + '</div>';
                }
            },
            formatCheckByZeroOrOne(value) {
                if (value === 1) {
                    return '<i class="fas fa-check" title="Igen"></i>';
                } else {
                    return '<i class="fas fa-minus" title="Nem"></i>';
                }
            },
            formatExpiredPackages(expired) {
                if (expired === 1) {
                    return '<div class="bg-danger">Lejárt</div>';
                } else {
                    return '<div class="bg-success">Elérhető</div>';
                }
            },
            formatMaleOrFemale(value) {
                if (value === 0) {
                    return '<i class="fas fa-male"></i> <i class="fas fa-female"></i>';
                } else if (value === 1) {
                    return '<i class="fas fa-male" title="Csak férfinak írható fel"></i>';
                } else if (value === 3) {
                    return '<i class="fas fa-female" title="Csak nőnek írható fel"></i>';
                } else {
                    return '-';
                }
            },
            mihaidFormat(value) {
                if (value) {
                    if (value === 0) return "Nem értelmezett";
                    if (value === 1) return "Gyomorbántalmak [3. § (1) bekezdés I) pontja]";
                    if (value === 2) return "Cukorbetegség [3. § (1) bekezdés m) pontja]";
                    if (value === 3) return "Magas vérnyomás - RAS-ra ható készítmények [3. § (1) bekezdés n) pontja]";
                    if (value === 4) return "Szérum lipidszintet csökkentő anyagok [3. § (1) bekezdés o) pont]";
                } else {
                    return "";
                }
            },
            mihastatFormat(value) {
                if (value) {
                    if (value === -1) return "Célérték alatti vagy azonos";
                    if (value === 0) return "Nem értelmezett";
                    if (value === 1) return "Célérték fölötti";
                } else {
                    return ""
                }
            },
            tamtechnFormat(value) {
                if (value) {
                    if (value === 'NOMIN') return "Nominális";
                    if (value === 'HFIX') return "Hatóanyag fixesítés";
                    if (value === 'TFX') return "Terápiás fixesítés";
                    if (value === 'FIX') return "GYSE fixesítés";
                    if (value === 'KOMBI') return "Kombinációs szabály";
                    if (value === 'BIOL') return "Biológiai terápia szabályai";
                    if (value === 'LFX') return "LMWH szabályai alapján";
                } else {
                    return "";
                }
            },
            formatKulonl100(value) {
                let result = "";
                if (value) {
                    // az első karakter az üzemibaleset,
                    // a második honvédelmi,  a harmadik a hadirokkant írhatóságot kódolja.
                    // Ha a karakter a &apos;0&apos;, akkor nem írható, ha &apos;1&apos; akkor írható.
                    if (value.charAt(0) === "0") {
                        result = result + "Üzemibalesetre nem írható";
                    } else {
                        result = result + "Üzemibalesetre írható";
                    }
                    if (value.charAt(1) === "0") {
                        result = result + ", Honvédelmire nem írható";
                    } else {
                        result = result + ", Honvédelmire írható";
                    }
                    if (value.charAt(2) === "0") {
                        result = result + ", Hadirokkantra nem írható";
                    } else {
                        result = result + ", Hadirokkantra írható";
                    }
                }
                return result;
            },
            beutaloOrvosFormat(rowData) {
                if (rowData.beutaloOrvos) {
                    return rowData.beutaloOrvos.lastName + " " + rowData.beutaloOrvos.firstName + " (" + rowData.beutaloOrvos.stampNo + ")";
                } else {
                    return "";
                }
            },
            fullPointFormat(row) {
                return row.theoriticalPoint + row.practicalPoint;
            },
            setRowActionButtonDisable(row, rowAction) {
                if (rowAction.additionalButtonDisable) {
                    switch(rowAction.additionalButtonDisable) {
                        case "canPrintPrescription":
                            return !row.canPrintPrescription;
                    }
                } else {
                    return false;
                }
            },
            setRowActionButtonVisible(row, rowAction, additionalData) {
                if (rowAction.additionalButtonVisible) {
                    switch (rowAction.additionalButtonVisible) {
                        case "isDocumentValidated":
                            return !row.validated && row.deleted === 0;
                        case "isDocumentValidatedReopen":
                            return row.validated && row.deleted === 0;
                        case "isShowPatientShowDetailsButton":
                            if(row.patientId){
                                return UserUtil.hasPermission('ATTENDANCE_VIEW');
                            }else{
                                return false;
                            }
                        case "isShowPayButton":
                            if(row.patientId&& ![2, 7, 8, 10].includes(row.appointmentStatus.id)){
                                if(UserUtil.hasPermission('PATIENT_ATTENDANCE_PAY')){
                                    return true;
                                }else{
                                    return false;
                                }
                            }else{
                                return false;
                            }
                        case "isShowGetCovidPcrResults":
                            return UserUtil.userHasEESZTPermission();
                        case "isShowUploadToEesztSpecialRecommendation":
                            return UserUtil.userHasEESZTPermission() && !row.eesztId;
                        case "isShowPrintFromEesztSpecialRecommendation":
                            return UserUtil.userHasEESZTPermission() && row.eesztId;
                        case "isShowInsertEkat":
                            return UserUtil.userHasEESZTPermission() && !row.eesztId;
                        case "isShowEditEkat":
                            return UserUtil.userHasEESZTPermission() && row.eesztId && row.treatmentCategoryId !== 28013;
                        case "isShowSetEBeuBtn":
                            return UserUtil.userHasEESZTPermission() && row.eesztId && !row.ebeutaloEesztId;
                        case "isProformaInvoicePaid":
                            if(row.isPaid && row.deleted === 0 && row.isUsed === false) {
                                return true;
                            }else{
                                return false;
                            }
                        case "isProformaInvoiceNotPaid":
                            if(row.isPaid === false && row.deleted === 0) {
                                return true;
                            } else {
                                return false;
                            }
                        case "isProformaInvoiceDeletable":
                            if(row.isUsed === false && row.deleted === 0&& row.isPaid === false) {
                                return true;
                            } else {
                                return false;
                            }
                        case "isShowSendEHR":
                            return UserUtil.userHasEESZTPermission() && !row.eesztId;
                        case "userHasSendLabPermission":
                            return UserUtil.hasPermission('SEND_EVIDENCE_DOCUMENT') && row.deleted === 0;
                        case "isNotSynlabSent":
                            return row.synlabSent == 0 && row.deleted === 0;
                        case "hasLabHandleDeletePermissionAndIsBilled":
                            return UserUtil.hasPermission('LAB_HANDLE_DELETE') && row.billed !== true;
                        case "hasLabHandleViewPermission":
                            return UserUtil.hasPermission('LAB_HANDLE_VIEW');
                        case "hasAttendancePermission":
                            return UserUtil.hasPermission('ATTENDANCE_VIEW');
                        case "hasCarePackageUnassignPermission":
                            return UserUtil.hasPermission('CARE_PACKAGE_UNASSIGN');
                        case "hasRoleEditBackofficeEditSalary":
                            return !UserUtil.hasRole('ROLE_BACKOFFICE_EDIT_SALARY') && row.deleted === 0;
                        case "hasRoleEditBackofficeEditSalaryForUndelete":
                            return !UserUtil.hasRole('ROLE_BACKOFFICE_EDIT_SALARY') && row.deleted === 1;
                        case "hasCallCenterRole":
                            return !UserUtil.hasRole('ROLE_CALL_CENTER_EMPLOYEE') && row.deleted === 0;
                        case "hasCallCenterRoleAndIsEditable":
                            return this.hasCallCenterRoleAndIsEditable(row);
                        case "canCarcinogenicProtocolStart":
                            return row.canSetCarcinogenicProtocolStarted && !row.isCarcinogenicProtocolStarted
                        case "unDeleteVisible":
                            return this.unDeleteVisible(row);
                        case "seeOptionsForDocumentHistory":
                            if(this.queryParams.page == 1){
                                if(row.id == this.rows[0].id){
                                    return false
                                }else{
                                    return true
                                }
                            }else{
                                return true
                            }
                        case "interReferralEditButtonVisibility":
                            return this.modifyInternalReferralEditButtonVisibility(row)
                        case "internalReferralDeleteButtonVisibility":
                            return this.modifyInternalReferralEditButtonVisibility(row)          
                        case "activationVisible":
                            return this.activationStateChangeVisible(row);
                        case "deActivationVisible":
                            return this.deActivationStateChangeVisible(row);
                        case "endEmploymentRelationshipButton":
                            return this.endEmploymentRelationshipButtonVisible(row)    
                        case "hasCallCenterRoleAndIsDeleteable":
                            return !UserUtil.hasRole('ROLE_CALL_CENTER_EMPLOYEE') && row.deleted == 0 && (!row.billed || row.lockedByRichter)
                        case "showPatientAttendanceTableButton":
                            return UserUtil.hasPermission('ATTENDANCE_VIEW');
                        case "showPatientAttendanceTableButtonIsAppointment":
                            return UserUtil.hasPermission('ATTENDANCE_VIEW') && row.appointmentId == additionalData.id;
                        case "hasRoleSeniorAssistantOrDoctorCoordinatorOrFeuAdmin":
                            if(UserUtil.hasRole('ROLE_SENIOR_ASSISTANT') || UserUtil.hasRole('ROLE_MEDICAL_COORDINATOR') || UserUtil.hasRole('ROLE_FEU_ADMIN')){
                              return UserUtil.hasPermission('ATTENDANCE_VIEW');
                            }
                            break
                        case "hasRoleSeniorAssistantOrDoctorCoordinatorOrFeuAdminOrBackofficeManager":
                            if(UserUtil.hasRole('ROLE_SENIOR_ASSISTANT') || UserUtil.hasRole('ROLE_MEDICAL_COORDINATOR') || UserUtil.hasRole('ROLE_FEU_ADMIN')||UserUtil.hasRole('ROLE_BACKOFFICE_MANAGER')){
                                return false;
                            }else {
                                return true;
                            }
                        case "hasRoleSeniorAssistantOrDoctorCoordinatorOrFeuAdminSeeCaseOfDeleted":
                            if((UserUtil.hasRole('ROLE_SENIOR_ASSISTANT') || UserUtil.hasRole('ROLE_MEDICAL_COORDINATOR') || UserUtil.hasRole('ROLE_FEU_ADMIN'))
                             && (row.deleted === 1 || row.deleted === 0) ){
                                return false
                            }else if(row.deleted === 1){
                                return true
                            }
                            break
                        case "isEditORDeleteButtonVisibleInEmployAbilityDoctorTemplate":
                            if(UserUtil.hasRole('ROLE_FEU_ADMIN') || UserUtil.hasRole('ROLE_FINANCE_MANAGER') || row.deleted === 1){
                                return false
                            }else if(row.deleted === 0){
                                return true
                            }
                            break
                        case "isUnDeletedButtonVisibleInEmployAbilityDoctorTemplate":
                          if(UserUtil.hasRole('ROLE_FEU_ADMIN') || UserUtil.hasRole('ROLE_FINANCE_MANAGER')){
                            return false
                          }else if (row.deleted === 1){
                            return true
                            }
                          break
                        case "needPrintPrescriptionCertificate":
                            return row.needPrintPrescriptionCertificate;
                        case "deletePrintVisible":
                            return row.receptStatusz !== "6" && row.feliroOrvosPecsetszam === this.getUser.eesztUsername.substring(1);
                        case "deletePrintVisibleGyse":
                            return (row.status === "Nyitott" || row.status === "Foglalt" || row.status === "Jogorvoslat alatt" || row.status === "Ellenjegyzésre vár") && row.feliroOrvosPecsetszam === this.getUser.eesztUsername;
                        case "isShowInsertEkatOperation":
                            return UserUtil.userHasEESZTPermission() && !row.attendance.eesztId;
                        case "isShowEditEkatOperation":
                            return UserUtil.userHasEESZTPermission() && row.attendance.eesztId;
                        case "loadButtonVisible":
                            return !row.loaded;
                        case "successfullyLoadedButtonVisible":
                            return row.loaded;
                        case "eesztResendButtonVisible":
                            return row.status === "FAILED";
                        case "isShowCovidButtons":
                            return row.labTypeId === 13005;
                        case "isNotCanceledInvoice":
                            return !row.canceled && row.invoiceTypeId !== 21016 && row.prePaymentOf == null;
                        case "haveInvoiceNumber":
                            return !!row.invoiceNumber;
                        case "isShowEditOccuHeaReferral":
                            return row.deleted === 0 && !row.used;
                        case "isShowEditOccuHeaReferral2":
                            return row.deleted === 0 && row.hasFile;
                        case "isShowEditOccuHeaReferral3":
                            return row.deleted === 0 && row.hasFile;
                        case "isShowPrintDriverLicenseEeszt":
                            return row.deleted === 0 && row.eesztEdocId && row.eesztAttachmentId;
                        case "addFeuContactUserButtonVisible":
                            return !row.userId;
                        case "xlsImportValidateXlsButtonVisible":
                            return row.statusId === 47001;
                        case "xlsImportModifyXlsButtonVisible":
                            return row.statusId === 47001 || row.statusId === 47002 || row.statusId === 47004 || row.statusId === 47005;
                        case "xlsImportImportXlsButtonVisible":
                            return row.statusId === 47002;
                        case "xlsImportShowXlsLogButtonVisible":
                            return row.statusId === 47003 || row.statusId === 47004;
                        case "xlsImportRollbackXlsButtonVisible":
                            return row.statusId === 47003;
                        case "isSynlabLabTypePriceList":
                            return row.id !== -1 && row.deleted === 0;
                        case "isReadyForEtikett":
                            return row.readyForEtikett && row.deleted === 0;
                        case "isPartnerActive":
                            if (row.partner) {
                                return row.partner.active === 0 && row.deleted === 0;
                            } else {
                                return true
                            }
                        case "isDeleteOrCopyVisibleOnDoctor":
                            if(UserUtil.hasRole('ROLE_BACKOFFICE_EDIT_SALARY')){
                                return false
                            }else{
                                return true
                            }
                        case "hasEmailTemplateEditPermission":
                            if(UserUtil.hasPermission('EMAIL_TEMPLATE_EDITOR_MENU')&&row.deleted==0) {
                                return true
                            }else{
                                return false
                            }
                        case "hasTreatmentTypeEditPermission":
                            if(UserUtil.hasPermission('TREATMENT_EDIT')&& row.deleted === 0) {
                                return true
                            }else {
                                return false
                            }
                        case "hasTreatmentTypeCreatePermission":
                            if(UserUtil.hasPermission('TREATMENT_ADD')&& row.deleted === 0) {
                                return true
                            }else {
                                return false
                            }
                        case "hasTreatmentTypeDeletePermission":
                            if(UserUtil.hasPermission('TREATMENT_DELETE')&& row.deleted === 0) {
                                return true
                            } else {
                                return false
                            }
                        case "deactivateCompanySiteVisible":
                            if (row.active === 0) {
                                return true
                            } else {
                                return false
                            }
                        case "richterReadyStatus":
                            if (row.deleted === 1) {
                                return false
                            } else if((row.statusId === 161002 || row.status === "Kész") && (!row.partner || row.partner.active === 0) && row.richterRequestId){
                                return false
                            } else {
                                return true
                            }
                        case "canSendEeszt": 
                            return row.deleted !== 1 && !row.eesztEdocId && row.validated === 1
                        case "canDeleteEeszt": 
                            return row.deleted !== 1 && !!row.eesztEdocId && row.validated === 1
                    }
                } else {
                    if (row.deleted === undefined || rowAction.seeDefinitely) {
                        return true;
                    } else if (row.deleted !== undefined && row.deleted === 0) {
                        return !(rowAction.seeCaseOfDeleted !== undefined && rowAction.seeCaseOfDeleted);
                    } else if (row.deleted !== undefined && row.deleted === 1) {
                        return rowAction.seeCaseOfDeleted !== undefined && rowAction.seeCaseOfDeleted;
                    }
                }
            },
            modifyInternalReferralEditButtonVisibility(row){
                const datePattern = /\d{4}\.\d{2}\.\d{2} \d{2}:\d{2}/;
                if((row.referralStatus !== "Lejárt" && !datePattern.test(row.referralStatus)) && row.deleted === 0 && (row.doctorId === this.isSpecificDoctorId)){
                    return true
                } else {
                    return false
                }
            },
            modifyInternalReferralDeleteButtonVisibility(row){
                const datePattern = /\d{4}\.\d{2}\.\d{2} \d{2}:\d{2}/;
                if(datePattern.test(row.referralStatus)){
                    return false
                }else{
                    return true
                }
            },
            activationStateChangeVisible(row) {
                if (row.activationStatus === 1 && row.deleted === 0) {
                    return true;
                } else {return false }
             },
            deActivationStateChangeVisible(row) {
                if (row.activationStatus === 0 && row.deleted === 0) {
                    return true;
                } else {return false }
             },
             endEmploymentRelationshipButtonVisible(row) {
                if (!row.employmentRelationshipEndDate && row.deleted === 0) {
                    return true;
                } else {
                    return false; 
                }
            },
            unDeleteVisible(row){
                if(row.deleted === 1){
                    if(row.isSynlabType){
                        if(row.synlabSent == 1){
                            if(!row.needToDelete){
                                return true
                            }else{
                                return false
                            }
                        }else{
                            return true
                        }
                    }else{
                        return true
                    }
                }else{
                    return false
                }
            },
            hasCallCenterRoleAndIsEditable(row){
                if(!UserUtil.hasRole('ROLE_CALL_CENTER_EMPLOYEE')){
                    if(row.deleted == 0){
                        if(row.isSynlabType){
                            if(row.synlabSent == 1 || row.billed || row.lockedByRichter){
                                return false
                            }else{
                                return true
                            }
                        }else{
                            if(row.billed || row.lockedByRichter){
                                return false
                            }else{
                                return true
                            }
                        }
                    }else{
                        return false
                    }
                }else{
                    false
                }
            },
            repeatsFormatter(data) {
                let rep = data.repeats === "week" ? "héten" : "hónapban";

                if (data.repeatsEvery == 1) {
                    return "Minden " + rep;
                } else {
                    return "Minden " + data.repeatsEvery + ". " + rep;
                }
            },
            daysFormatter(data) {
                let result = '';
                data.repeatsOnDays.forEach(item => {
                    result = result + ', ' + item.text;
                });
                return result.substr(2);
            },
            startEndDateFormatter(rowData) {
                let startDate = this.$moment(rowData.date).format("YYYY.MM.DD.");
                let endDate = this.$moment(rowData.endDate).format("YYYY.MM.DD.");
                return startDate + ' - ' + endDate;
            },
            TimeWithSecondsToHoursFormatter(rowData) {
                if(rowData.sendToSynlabTime){
                    return this.$moment(rowData.sendToSynlabTime, 'HH:mm:ss').format('HH:mm')
                }else{
                    return ''
                }
            },
            startEndTimeFormatter(rowData) {
                let startValues = rowData.startTime.split(":");
                let endValues = rowData.endTime.split(":");
                return startValues[0] + ":" + startValues[1] + ' - ' + endValues[0] + ":" + endValues[1];
            },
            formatHolidayDateFromTo(row) {
                let startDate = this.$moment(row.startDate).format("YYYY.MM.DD.");
                let endDate = this.$moment(row.endDate).format("YYYY.MM.DD.");
                return startDate + ' - ' + endDate;
            },
            companySiteFormat(row) {
                return row.companySite != null ? row.companySite.siteName : 'Minden telephely';
            },
            formatEmployeeStatus(row) {
                if(row.activationStatusId == 2400){
                    return '<div class="bg-success">' + row.status + '</div>';
                }else if(row.activationStatusId == 2401){
                    return '<div class="bg-danger">' + row.status + '</div>';
                }else if(row.activationStatusId == 2402){
                    return '<div class="bg-warning">' + row.status + '</div>';
                }
            },
            operationFormat(operation) {
                switch (operation) {
                    case 'INSERT':
                        return 'Létrehozás';
                    case 'DELETE':
                        return 'Törlés';
                    case 'UPDATE FROM':
                        return 'Módosítás (eredeti)';
                    case 'UPDATE TO':
                        return 'Módosítás (új)';
                    default:
                        return '?'
                }
            },
            formatEsemenyStatus(value) {
                return Util.formatEsemenyStatus(value);
            },
            eesztStatusFormat(value) {
                if (value === "SUCCESS") {
                    return "Sikeres";
                } else {
                    return "Sikertelen";
                }
            },
            formatEsemenyTipus(value) {
                return Util.formatEsemenyTipus(value);
            },
            patientNameFormat(rowData) {
                if (rowData.patient) {
                    return rowData.patient.name;
                } else {
                    return rowData.patientName;
                }
            },
            patientPhoneNumberFormat(rowData) {
                if (rowData.patient) {
                    return rowData.patient.phoneNumber;
                } else {
                    return rowData.patientPhone;
                }
            },
            formatOperationStart(rowData) {
                let startValues = rowData.startTime.split(":");
                return this.$moment(rowData.startDate).format("YYYY.MM.DD.") + " " + startValues[0] + ":" + startValues[1];
            },
            formatOperationEnd(rowData) {
                let endValues = rowData.endTime.split(":");
                return this.$moment(rowData.endDate).format("YYYY.MM.DD.") + " " + endValues[0] + ":" + endValues[1];
            },
            formatLoaded(rowData) {
                if (rowData.loaded) {
                    return '<i class="fas fa-check" title="Betöltve"></i>';
                } else {
                    return '<i class="fas fa-minus" title="Nincs betöltve"></i>';
                }
            },
            stornoFormat(canceled) {
                if (canceled) {
                    return '<i class="fas fa-check"></i>';
                } else {
                    return '<i class="fas fa-minus"></i>';
                }
            },
            proformaInvoicePaidFormat(paid) {
                if (paid) {
                    return '<i class="fas fa-check" style="color: green"></i>';
                } else {
                    return '<i class="fas fa-times" style="color: red"></i>';
                }
            },
            companySiteDeactivationFormat(deactivated) {
                if (deactivated===0) {
                    return '<i class="fas fa-check" style="color: green"></i>';
                } else {
                    return '<i class="fas fa-times" style="color: red"></i>';
                }
             },

            synlabTypeIconFormat(data) {
                if(data.row.synlabPackageId){
                    return '<div v-b-tooltip.hover title="SYNLAB paletta tétel"><i class="fas fa-vials"></i></div>';
                } else if (data.row.isHiddenItem) {
                    return '<div v-b-tooltip.hover title="Rejtett tétel"><i class="fas fa-eye-slash"></i></div>';
                } else if(data.row.isSynlabType){
                    return '<div v-b-tooltip.hover title="SYNLAB labortípus"><i class="fas fa-vial"></i></div>';
                } else {
                    return '<div v-b-tooltip.hover title="Labortípus"><i class="fas fa-flask"></i></div>';
                }
            },
            synlabTypePackageIconFormat(data) {
                if(data.row.isSynlabType && data.row.packageTypeId == 1404){
                    return '<div style="width:50px !important" v-b-tooltip.hover title="SYNLAB gyűjtemény csomag"><i class="fas fa-vial"></i></div>';
                } else if (!data.row.isSynlabType && data.row.packageTypeId == 1404) {
                    return '<div style="width:50px !important" v-b-tooltip.hover title="Gyűjtemény csomag"><i class="fas fa-flask"></i></div>';
                } else if(data.row.isSynlabType && data.row.packageTypeId == 1405){
                    return '<div style="width:50px !important" v-b-tooltip.hover title="SYNLAB áras palletta csomag"><i class="fas fa-dollar-sign"></i> <i class="fas fa-vial"></i></div>';
                } else  if(!data.row.isSynlabType && data.row.packageTypeId == 1405){
                    return '<div style="width:50px !important" v-b-tooltip.hover title="Áras palletta csomag"><i class="fas fa-dollar-sign"></i> <i class="fas fa-flask"></i></div>';
                } else if(data.row.packageTypeId == 1406){
                    return '<div style="width:50px !important" v-b-tooltip.hover title="SYNLAB paletta csomag"><i class="fas fa-vials"></i></div>';
                }
            },
            synlabTypeIconFormatForLabs(isSynlabType) {
                if (isSynlabType) {
                  return '<div v-b-tooltip.hover title="SYNLAB labor"><i class="fas fa-vial"></i></div>';
                } else {
                  return '<div v-b-tooltip.hover title="Labor"><i class="fas fa-flask"></i></div>';
                }
            },
            formatDatetimeCheckIfDateIsNotActual(validTo) {
                if (validTo) {
                    let currentDate = this.$moment().startOf('day');
                    let validToDate = this.$moment(validTo);
                    let formattedDate = validToDate.format("YYYY.MM.DD.");
                    if (validToDate.isBefore(currentDate)) {
                        return '<div class="bg-danger" data-toggle="tooltip" data-placement="right" title="Lejárt alkalmassági">' + formattedDate + '</div>';
                    } else {
                        return formattedDate;
                    }
                } else {
                    return "";

                }
            },
            isNullFormat(data) {
                if (data) {
                        return data;
                } else {
                    return "Nincs megadva";

                }
            },
            formatCommission(commission) {
                let formatter = new Intl.NumberFormat('hu-HU', {
                    style: 'currency',
                    currency: 'HUF',
                    minimumFractionDigits: 0
                });
                return formatter.format(commission);
            },
            currencyFormatByCurrencyType(amount,currencyType) {
                if(currencyType === 'HUF'){
                    let formatter = new Intl.NumberFormat('hu-HU', {
                        style: 'currency',
                        currency: 'HUF',
                        minimumFractionDigits: 0
                    });
                    return formatter.format(amount);
                }else if(currencyType === 'EUR'){
                    let formatter = new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR',
                        minimumFractionDigits: 0
                    });
                    return formatter.format(amount);
                }
            },
            formatCommission2(commission) {
                if (commission === undefined) {
                    return 'Nincs támogatási alap';
                }
                let formatter = new Intl.NumberFormat('hu-HU', {
                    style: 'currency',
                    currency: 'HUF',
                    minimumFractionDigits: 0
                });
                return formatter.format(commission);
            },
            formatVersion(version) {
                return "v." + version;
            },
            // commissionAmountFormat(row) {
            //     let formatter = new Intl.NumberFormat('hu-HU', {
            //         style: 'currency',
            //         currency: 'HUF',
            //         minimumFractionDigits: 0
            //     });
            //     if (row.amount) {
            //         return formatter.format(row.amount);
            //     } else {
            //         let result = row.treatmentPrice * row.percent / 100;
            //         return formatter.format(result);
            //     }
            // },
            formatEupont(rowData) {
                let result = "";
                if (rowData.eupontok.codeNum) {
                    result = result + rowData.eupontok.codeNum;
                }
                if (rowData.eupontok.codeNum && rowData.eupontok.perjel) {
                        result = result + "/"
                }
                if (rowData.eupontok.perjel) {
                       result = result + rowData.eupontok.perjel;
                }
                return result;
            },
            formatGYSE(rowData) {
                if (rowData.tipus === "S") {
                    if (rowData.patika === "I") {
                        return '<div class="bg-warning" data-toggle="tooltip" data-placement="right" title="eReceptre nem írható!">' + rowData.ttt +'</div>'
                    } else if (rowData.patika === "E") {
                        return '<div class="bg-success" data-toggle="tooltip" data-placement="right" title="eReceptre írható!">' + rowData.ttt +'</div>'
                    }
                }
                return rowData.ttt;
            },
            bnoSzinezes(rowData) {
                if (rowData.kod.length < 5) {
                    return '<div class="bg-danger" data-toggle="tooltip" data-placement="right" title="EESZT által nem elfogadva!">' + rowData.kod +'</div>'
                } else {
                    return rowData.kod;
                }
            },
            gyogyszerSzinezesForgalomban(rowData) {
                if (rowData.megszunt === true) {
                    return '<div class="bg-danger" data-toggle="tooltip" data-placement="right" title="A termék nincs forgalomban!">' + rowData.nev + '</div>';
                } else {
                    return '<div class="bg-transparent">' + rowData.nev + '</div>';
                }
            },
            gyogyszerSzinezes(rowData) {
                if (rowData.megszunt === true) {
                    return '<div class="bg-secondary" data-toggle="tooltip" data-placement="right" title="A termék nincs forgalomban!">' + rowData.nev + '</div>';
                }
                if (this.additionalData) {
                    switch (this.additionalData.jogcim) {
                        case "1":
                            // Normatív
                            return '<div ' + this.getColorAndPopoverByCode(rowData.besorolas.toString().substr(0, 1)) + '>' + rowData.nev + '</div>';
                        /*case "2":
                            // Teljes ár
                            return '<div class="bg-transparent">' + rowData.nev + '</div>';*/
                        case "3":
                            // Eü emelt
                            return '<div ' + this.getColorAndPopoverByCode(rowData.besorolas.toString().substr(1, 2)) + '>' + rowData.nev + '</div>';
                        case "4":
                            // Eü kiemelt
                            return '<div ' + this.getColorAndPopoverByCode(rowData.besorolas.toString().substr(3, 5)) + '>' + rowData.nev + '</div>';
                        case "5":
                            // közgyógy (KGY)
                            return '<div ' + this.getColorAndPopoverByCode(rowData.besorolas.toString().substr(0, 1)) + '>' + rowData.nev + '</div>';
                        case "6":
                            // KGY+Eü emelt
                            return '<div ' + this.getColorAndPopoverByCode(rowData.besorolas.toString().substr(1, 2)) + '>' + rowData.nev + '</div>';
                        case "7":
                            // KGY+Eü kiemelt
                            return '<div ' + this.getColorAndPopoverByCode(rowData.besorolas.toString().substr(3, 5)) + '>' + rowData.nev + '</div>';
                        /*case "8":
                            // HM
                            break;
                        /*case "9":
                            // Üzemi baleset
                            break;*/
                        default:
                            return '<div class="bg-transparent">' + rowData.nev + '</div>';
                    }
                } else {
                    return '<div class="bg-transparent">' + rowData.nev + '</div>';
                }
            },
            getColorAndPopoverByCode(code) {
                if (code === "1" || code === "01") {
                    return "class=\"font-weight-bold bg-success\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"Referencia termék.\"";
                } else if (code === "2" || code === "02") {
                    return "class=\"bg-success\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"A referenciakészítménynél alacsonyabb, vagy azzal egyenlő a napi terápiás költségű készítmény.\"";
                } else if (code === "3" || code === "03") {
                    return "class=\"bg-warning\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"A referenciakészítmény napi terápiás költségét kevesebb mint 20%-kal haladja meg a készítmény napi terápiás költsége.\"";
                } else if (code === "4" || code === "04") {
                    return "class=\"bg-danger\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"A referenciakészítmény napi terápiás költségét legalább 20%-kal meghaladja a készítmény napi terápiás költsége.\"";
                } else if (code === "5" || code === "05") {
                    return "class=\"bg-transparent\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"A készítmény nincs hatóanyag alapú fixcsoportba sorolva, ezért nem kerül besorolásra\"";
                } else if (code === "6" || code === "06") {
                    return "class=\"bg-secondary\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"A törzskönyvi törölt termék, legkésőbb három hónapon belül törlésre kerül a támogatási rendszerből\"";
                } else if (code === "7" || code === "07") {
                    return "class=\"bg-white\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"A eredetileg PRAS -on kívüli termékek, amelyek utólag a preferált referencia ársáv szintjére csökkentették árukat\"";
                }
            },
            puphaXTermekszinezes(rowData) {
                if (rowData.forgalomban === 0) {
                    return '<div class="bg-secondary" data-toggle="tooltip" data-placement="right" title="A termék nincs forgalomban!">' + rowData.nev + '</div>';
                } else {
                    if (this.additionalData) {
                        if (rowData.tamalaps.length > 0) {
                            let besorolasData = rowData.tamalaps[0].besorolas;
                            if (besorolasData == null) {
                                return '<div class="bg-transparent">' + rowData.nev + '</div>';
                            }
                        } else {
                            return '<div class="bg-transparent">' + rowData.nev + '</div>';
                        }
                        let besorolas = rowData.tamalaps[0].besorolas;
                        switch (this.additionalData.jogcim) {
                            case "1":
                                // Normatív
                                return '<div ' + this.getColorAndPopoverByCode(besorolas.toString().substr(0, 1)) + '>' + rowData.nev + '</div>';
                            case "3":
                                // Eü emelt
                                return '<div ' + this.getColorAndPopoverByCode(besorolas.toString().substr(1, 2)) + '>' + rowData.nev + '</div>';
                            case "4":
                                // Eü kiemelt
                                return '<div ' + this.getColorAndPopoverByCode(besorolas.toString().substr(3, 5)) + '>' + rowData.nev + '</div>';
                            case "5":
                                // közgyógy (KGY)
                                return '<div ' + this.getColorAndPopoverByCode(besorolas.toString().substr(0, 1)) + '>' + rowData.nev + '</div>';
                            case "6":
                                // KGY+Eü emelt
                                return '<div ' + this.getColorAndPopoverByCode(besorolas.toString().substr(1, 2)) + '>' + rowData.nev + '</div>';
                            case "7":
                                // KGY+Eü kiemelt
                                return '<div ' + this.getColorAndPopoverByCode(besorolas.toString().substr(3, 5)) + '>' + rowData.nev + '</div>';
                            default:
                                return '<div class="bg-transparent">' + rowData.nev + '</div>';
                        }
                    } else {
                        return '<div class="bg-transparent">' + rowData.nev + '</div>';
                    }
                }

            },
            indikaciokFormat(rowData) {
                let result = "";
                if (rowData.euindikaciok) {
                    rowData.euindikaciok.forEach(item => {
                        result = result + item.leiras + "; ";
                    })
                }
                else if (rowData.euIndikacio) {
                    rowData.euIndikacio.forEach(item => {
                        result = result + item.leiras + "; ";
                    })
                }
                return result;
            },
            kategoriaPuphaxFormat(rowData) {
                if (rowData.kategoriaText) {
                    return rowData.kategoriaText.leiras;
                }
                if (rowData.kategoriaId === 0) return "Megkötés nélkül";
                if (rowData.kategoriaId === 1) return "Fekvőbeteg gyógyintézet";
                if (rowData.kategoriaId === 2) return "Járóbeteg szakrendelés";
                if (rowData.kategoriaId === 3) return "Kijelölt intézmény";
                if (rowData.kategoriaId === 4) return "Járóbeteg szakrendelés/Fekvőbeteg gyógyintézet";
                if (rowData.kategoriaId === 5) return "Háziorvos";
                if (rowData.kategoriaId === 6) return "Kijelölt intézmény szakorvosa";
                if (rowData.kategoriaId === 7) return "Diabetológiai szakellátóhely";
                if (rowData.kategoriaId === 8) return "Menopauza és osteoporózis járóbeteg-szakrendelés";
                if (rowData.kategoriaId === 9) return "Fekvőbeteg gyógyintézeti háttérrel rendelkező járóbeteg szakr.";
                if (rowData.kategoriaId === 10) return "Gyermek- és ifjúságpszichiátriai járóbeteg szakrendelés";
                if (rowData.kategoriaId === 11) return "II. és III. progresszivitási szintű fekvőbeteg gyógyintézet";
                if (rowData.kategoriaId === 12) return "III. progresszivitási szintű fekvőbeteg gyógyintézet";
            },
            formatEesztCert(valid) {
                if (valid) {
                    return '<i class="fas fa-check text-green" style="color:green;" title="Érvényes"></i>';
                } else {
                    return '<i class="far fa-times-circle text-red" style="color:red;" title="Érvénytelen"></i>';
                }
            },
            validateFormat(valid) {
                if (!valid) {
                    return '<div class="bg-danger" data-toggle="tooltip" data-placement="right" title="Validálás nem történt">Validálás nem történt</div>';
                } else {
                    return '<div class="bg-success" data-toggle="tooltip" data-placement="right" title="Validált">Validált</div>';
                }

            },
            formatPatient(patientId) {
                if (patientId) {
                    return '<i class="fas fa-check text-green" style="color:green;" title="Van hozzárendelve páciens"></i>';
                } else {
                    return '<i class="far fa-times-circle text-red" style="color:red;" title="Nincs hozzárendelve páciens"></i>';
                }
            },
            protocolFormat(protocolText) {
                if (protocolText.length >= 30) {
                    return protocolText.substring(0, 27) + "...";
                } else {
                    return protocolText;
                }
            },
            emailStatusFormat(emailStatus) {
                switch (emailStatus) {
                    case "CREA":
                        return 'Létrehozva';
                    case "PEDDING":
                        return 'Küldés alatt';
                    case "DONE":
                        return 'Kiküldve';
                    case "ERROR":
                        return 'Hiba';
                    default:
                        return emailStatus;
                }
            },
            appointmentStatusColorCode(rowData) {
                return '<div style=" background-color:' + rowData.color + '; border: 1px solid black">' + rowData.color + '</div>';
            },
            bnoKodFormat(rowData) {
                if(rowData.row.isPrimary){
                    return '<b>'+rowData.cell_value+'</b>';
                }else{
                    return rowData.cell_value;
                }
            },
            formatAndColorExpirationDateTime(rowData) {
                if (rowData.dateOfExpiration) {
                    let momentExpirationDate = this.$moment(rowData.dateOfExpiration).format("YYYY.MM.DD.");
                    let now = new Date();
                    if (this.$moment(now).isAfter(rowData.dateOfExpiration, 'day')) {
                        return '<div class="bg-danger" data-toggle="tooltip" data-placement="right" title="Lejárt a lelet">' + momentExpirationDate + '</div>';
                    } else {
                        return '<div class="bg-success" data-toggle="tooltip" data-placement="right" title="Érvényes lelet">' + momentExpirationDate + '</div>';
                    }
                } else {
                    return '';
                }
            },
            tooltipForLaboratoryTypes(rowData) {
                if(rowData.comment !== null){
                    return '<div v-b-tooltip.hover title="' + rowData.comment + '">' + rowData.code +'</div>'
                }else{
                    return rowData.code;
                }
            },
            rowBreakAtComaFormat(rowData) {
                let formattedString = rowData.codedTreatments.split(",").join("<br>");
                return formattedString;
            },
            isContactPartner(rowData) {
                if(rowData.contactId == 821){
                    return rowData.partner.text
                }else{
                    if(rowData.contact){
                        return rowData.contact.text
                    }else{
                        return ''
                    }
                }
            },
            breakString(str, limit) {
                if (str == null || str == "" || str == undefined) {
                    return "";
                }

                let result = '';
                let lineLength = 0;

                const words = str.split(' ');

                for (const word of words) {
                    if (lineLength + word.length + 1 > limit) {
                        result += '\n';
                        lineLength = 0;
                    }
                    
                    result += (lineLength > 0 ? ' ' : '') + word;
                    lineLength += word.length + 1;
                }

                return result;
            },
            preTagFormat(str) {
                const formattedStr = this.breakString(str, 50);
                return '<pre class="text-left" style="font-family: Arial, monospace; font-size: 0.78rem">' + formattedStr + '</pre>';
            },
           rowBreakAtDotFormat(rowData) {
                let formattedString = rowData.actionText.split(".").join(".<br>");
                return formattedString;
            },
            intervalToNoDecimalFormat(rowData) {
                if (rowData.intervalInHours) {
                    let formatedInterval = +rowData.intervalInHours.toFixed(0);
                    return formatedInterval
                }
            },
            rowBreakAtEndSignFormat(rowData) {
                let formattedString = rowData.labTypes.split("&").join("<br>");
                return formattedString;
            },
            rowBreakAtSemicolon(rowData) {
                let formattedString = rowData.labs.split(";").join("<br>");
                return formattedString;
            },
        },
        mounted() {
            if (this.config.initOnRender && !this.config.server_mode) {
                this.fetchData();
            }
        },
        components: {
            NotificationModal,
            VueBootstrap4Table
        },
        computed: {
            ...mapGetters('userModel', ['getUser']),
        }
    }
</script>

<style type="scss" scoped>
    #data-table >>> table .form-group {
        margin-bottom: 0;
    }

    #data-table {
        min-height: 100%;
        position: relative;
    }

    #data-table >>> .card {
        min-height: 100%;
        width: 100%;
    }

    #data-table >>> .table th, #data-table >>> .table td {
        padding: 0.4rem;
    }

    #data-table >>> tbody td.text-center:last-of-type {
        white-space: nowrap;
    }

    #data-table >>> .table-action-button {
        padding: 2px 7px;
        margin-left: 2px;
        margin-right: 2px;
    }

    #data-table >>> .table-action-button i{
        font-size: 13px;
    }

    #data-table >>> .page-link {
        color: var(--default-color);
        background-color: #fff;
        border: 1px solid #dee2e6;
    }

    #data-table >>> .page-item.active .page-link {
        background-color: var(--default-color);
        border-color: var(--default-color);
        color: #fff;
    }

    #data-table >>> .btn-primary:not(:disabled):not(.disabled):active,
    #data-table >>> .show > .btn-primary.dropdown-toggle {
        color: #fff;
        background-color: var(--default-color);
        border-color: var(--default-color);
    }

    #data-table >>> .dropdown-item.active {
        color: #fff;
        text-decoration: none;
        background-color: var(--default-color);
    }

    #data-table >>> .dropdown-toggle {
        color: #fff;
        background-color: var(--default-color);
    }

    #data-table >>> .card-header {
        display: none;
    }

    #data-table >>> .table {
        margin: 0;
    }

    #data-table >>> .table th{
        font-size: 0.9em;
    }

    #data-table >>> .table td{
        font-size: 0.8em;
    }

</style>
